import { DOCUMENTATION_SYNC_AFTER_READ_INTERVAL_MS } from 'serviceWorker/const/syncTiming';
import * as directoriesService from 'serviceWorker/db/directories/directoriesService';
import * as documentationsService from 'serviceWorker/db/documentations/documentationsService';
import { directoriesSync } from 'serviceWorker/services/directories';
import { documentationsSync } from 'serviceWorker/services/documentations';
import { createThrottledReadStorage } from 'serviceWorker/services/factories/createThrottledReadStorage';
import { directoryContract } from 'shared/domain/directory/directoryContract';
import { documentationContract } from 'shared/domain/documentation/documentationContract';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { createDocumentationModuleReads } from './model';

export type {
  DocumentationModuleReads,
  DocumentationReadOptions,
} from './types';

export const documentationModuleReads = createDocumentationModuleReads({
  documentations: createThrottledReadStorage({
    service: documentationsService,
    contract: documentationContract,
    collectionEvent: DomainMessagesTypes.allDocumentations,
    synced: documentationsSync,
    refreshIntervalMs: DOCUMENTATION_SYNC_AFTER_READ_INTERVAL_MS,
  }),
  directories: createThrottledReadStorage({
    service: directoriesService,
    contract: directoryContract,
    collectionEvent: DomainMessagesTypes.allDirectories,
    synced: directoriesSync,
    refreshIntervalMs: DOCUMENTATION_SYNC_AFTER_READ_INTERVAL_MS,
  }),
});
